import React, { Component } from 'react';
import { FaInstagram, FaFacebook, FaTwitter } from 'react-icons/fa';
import A from '../../../shared/Anchor/Anchor';
import './SocialMedia.scss';
import { LogoX } from '../../Icons/LogoX';

class SocialMedia extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    const { datiFarmacia, topHeaderSecondaryVersion } = this.props;

    return (
      <div className="social-media-container">
        {(datiFarmacia.socialTwitterLink ||
          datiFarmacia.socialFacebookLink ||
          datiFarmacia.socialInstagramLink) && (
          <div className="social">
            {datiFarmacia.socialTwitterLink && (
              <A
                className="social-link"
                href={datiFarmacia.socialTwitterLink}
                target="_blank"
                style={{ opacity: 1 }}
              >
                <LogoX
                  fill={topHeaderSecondaryVersion === 2 ? '#000' : '#fff'}
                />
              </A>
            )}
            {datiFarmacia.socialFacebookLink && (
              <A
                className="social-link"
                href={datiFarmacia.socialFacebookLink}
                target="_blank"
                style={{ opacity: 1 }}
              >
                <FaFacebook
                  style={{
                    fill: topHeaderSecondaryVersion === 2 ? '#000' : '#fff',
                  }}
                />
              </A>
            )}
            {datiFarmacia.socialInstagramLink && (
              <A
                className="social-link"
                href={datiFarmacia.socialInstagramLink}
                target="_blank"
                style={{ opacity: 1 }}
              >
                <FaInstagram
                  style={{
                    fill: topHeaderSecondaryVersion === 2 ? '#000' : '#fff',
                  }}
                />
              </A>
            )}
          </div>
        )}
      </div>
    );
  }
}
export default SocialMedia;
